import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import RefreshIcon from '@mui/icons-material/Refresh';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import { Box, Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface NotificationToolbarProps {
  selectedCount: number;
  onMarkAllRead: () => void;
  onSettings: () => void;
  onRefresh: () => void;
  onBulkMarkRead: () => void;
  onBulkArchive: () => void;
  onBulkDelete: () => void;
  onBulkExport: () => void;
}

export const NotificationToolbar = memo(function NotificationToolbar({
  selectedCount,
  onMarkAllRead,
  onSettings,
  onRefresh,
  onBulkMarkRead,
  onBulkArchive,
  onBulkDelete,
  onBulkExport,
}: NotificationToolbarProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Box>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1}
        justifyContent="space-between"
        alignItems={{ xs: 'stretch', md: 'center' }}
      >
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Button
            variant="outlined"
            startIcon={<TaskAltOutlinedIcon />}
            onClick={onMarkAllRead}
          >
            {t('notificationCenter.markAllAsRead')}
          </Button>
          <Button
            variant="outlined"
            startIcon={<SettingsOutlinedIcon />}
            onClick={onSettings}
          >
            {t('notificationCenter.settings')}
          </Button>
          <Button
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={onRefresh}
          >
            {t('notificationCenter.refresh')}
          </Button>
        </Stack>

        {selectedCount > 0 ? (
          <Stack
            direction="row"
            spacing={1}
            flexWrap="wrap"
            alignItems="center"
          >
            <Typography variant="subtitle2" color="text.secondary">
              {t('notificationCenter.selectedCount', { count: selectedCount })}
            </Typography>
            <Button
              size="small"
              startIcon={<MarkEmailReadOutlinedIcon />}
              onClick={onBulkMarkRead}
            >
              {t('notificationCenter.markRead')}
            </Button>
            <Button
              size="small"
              startIcon={<ArchiveOutlinedIcon />}
              onClick={onBulkArchive}
            >
              {t('notificationCenter.archive')}
            </Button>
            <Button
              size="small"
              startIcon={<DeleteOutlineIcon />}
              onClick={onBulkDelete}
            >
              {t('notificationCenter.delete')}
            </Button>
            <Button
              size="small"
              startIcon={<DownloadOutlinedIcon />}
              onClick={onBulkExport}
            >
              {t('notificationCenter.export')}
            </Button>
          </Stack>
        ) : null}
      </Stack>
    </Box>
  );
});
